import { Injectable } from '@angular/core';
import { CommandFactoryService } from '../../../../core/service/factory/command-factory.service';
import { MultiselectCommand } from '../../../../core/model/command';
import { ControlDataExportMultiselectCommand } from '../../../command/control-data-export.command';
import { TransferMultiselectCommand } from '../../../command/transfer-multiselect.command';

@Injectable()
export class CooperativeHousingTransferCommandFactory extends CommandFactoryService {
  constructor() {
    super();
  }

  createMultiselectCommand(id: string, items: any[], itemsSource: any[], contextId?: string): MultiselectCommand {
    return new TransferMultiselectCommand(id, items, itemsSource, contextId);
  }
}
